import { http } from "../utils/http";

/** KPI (КПЭ) — backend /v1/kpi. [Claude] 2026-11-02, Чат 6, №10. */
export const getKpiOverview = (period, unitId) =>
    http.get(`/kpi/overview?period=${encodeURIComponent(period)}${unitId ? `&unit_id=${encodeURIComponent(unitId)}` : ""}`);
export const getKpiGroups = () => http.get("/kpi/groups");
export const updateKpiGroup = (id, data) => http.patch(`/kpi/groups/${id}`, data);
export const createKpiGroup = (data) => http.post("/kpi/groups", data);
export const getKpiMonth = (id) => http.get(`/kpi/months/${id}`);
export const createKpiMonth = (data) => http.post("/kpi/months", data);
export const updateKpiMonth = (id, data) => http.put(`/kpi/months/${id}`, data);
export const createKpiCard = (monthId, data) => http.post(`/kpi/months/${monthId}/cards`, data);
export const saveKpiCard = (id, data) => http.put(`/kpi/cards/${id}`, data);
export const deleteKpiCard = (id) => http.del(`/kpi/cards/${id}`);
export const previewKpiCard = (monthId, card) => http.post("/kpi/preview", { month_id: monthId, card });

/** №35 (03.11): доступ и ручная привязка к структуре компании. [Claude] */
export const getKpiMe = () => http.get("/kpi/me");
export const getKpiLinks = () => http.get("/kpi/links");
export const getKpiEmployees = () => http.get("/kpi/employees");
export const setKpiGroupUnits = (groupId, unitIds) => http.put(`/kpi/groups/${groupId}/units`, { unit_ids: unitIds });
export const setKpiCardEmployee = (cardId, employeeId, allMonths = true) =>
    http.put(`/kpi/cards/${cardId}/employee?all_months=${allMonths ? "true" : "false"}`, { employee_id: employeeId });
export const getKpiAccess = () => http.get("/kpi/access");
export const addKpiAccessRule = (rule) => http.post("/kpi/access/rules", rule);
export const deleteKpiAccessRule = (id) => http.del(`/kpi/access/rules/${id}`);
